import { Link } from 'react-router-dom'
import s from './CompanyDetails.scss'

const CompanyDetails = ({ company }) => {
  return (
    <>
      <Link className={s.companyLink} to={`/companies/${company.id}`}>
        {company.name}
      </Link>
      {company.contacts && (
        <ul className={s.companyContacts}>
          {company.contacts.map(contact => (
            <li key={contact.id}>
              <Link to={`/contacts/${contact.id}`}>
                {contact.firstName} {contact.lastName}
              </Link>
            </li>
          ))}
        </ul>
      )}
    </>
  )
}

export default CompanyDetails
